"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const PreferencesContext_1 = require("../../context/PreferencesContext");
const usePanelPreferences_1 = require("../../hooks/usePanelPreferences");
const PreferencesContainer_1 = require("../extra/preferences/PreferencesContainer");
const PredictionOptionsPanel_1 = __importDefault(require("./PredictionOptionsPanel"));
function PredictionPreferences(props, ref) {
    const formRef = (0, react_1.useRef)(null);
    const preferences = (0, PreferencesContext_1.usePreferences)();
    const predictionPreferences = (0, usePanelPreferences_1.usePanelPreferences)('prediction');
    const saveHandler = (0, react_1.useCallback)((values) => {
        preferences.dispatch({
            type: 'SET_PANELS_PREFERENCES',
            payload: { key: 'prediction', value: values },
        });
    }, [preferences]);
    (0, react_1.useImperativeHandle)(ref, () => ({
        saveSetting: () => {
            formRef.current.submitForm();
        },
    }), []);
    return ((0, jsx_runtime_1.jsx)(PreferencesContainer_1.PreferencesContainer, { style: { backgroundColor: 'white' }, children: (0, jsx_runtime_1.jsx)(PredictionOptionsPanel_1.default, { onSubmit: saveHandler, options: predictionPreferences, ref: formRef, hideName: true }) }));
}
exports.default = (0, react_1.forwardRef)(PredictionPreferences);
